// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-analysis-assembly-layout-flex{display:flex;flex:0.1 1 120rem;flex-direction:column;flex-wrap:wrap;margin:0 auto;max-width:100%}.product-analysis-assembly-layout-flex .flex-wrapper-1{flex:1}.product-analysis-assembly-layout-flex .check-options{display:flex;flex-direction:'row';flex-wrap:nowrap}\n", ""]);
// Exports
module.exports = exports;
